import { SeedbedQuality } from '../../constants/SeedbedQuality';
import { SoilType } from '../../constants/SoilType';
import { Crop } from '../../constants/CropConstants';
import { Climate } from '../../constants/Climate';

export type SeedingCalculator = {
  isOrganic: boolean;
  tgw: number | null; // thousand grain weight
  germinationPercentage: number | null;
  unitsPerSack: number | null;
  sackWeight: number | null;
  seedingDate: Date;
  seedbedQuality: SeedbedQuality;
  soilType: SoilType | null;
  selectedCrop: Crop;
  result: number;
  climate: Climate;
  identifier: Identifier;
  version: number;
};

export enum Identifier {
  DANISH_SEEDING_MODEL = 'DANISH_SEEDING_MODEL',
}
